"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.describePrSkip = exports.itPrSkip = void 0;
var itPrSkip = function (title, fn) {
    if (process.env.agentType === 'pullrequest') {
        console.log("SKIPPING IN PR:", title);
        it.skip(title, fn);
    }
    else {
        it(title, fn);
    }
};
exports.itPrSkip = itPrSkip;
var describePrSkip = function (title, fn) {
    if (process.env.agentType === 'pullrequest') {
        console.log("SKIPPING IN PR:", title);
        describe.skip(title, fn);
    }
    else {
        describe(title, fn);
    }
};
exports.describePrSkip = describePrSkip;
//# sourceMappingURL=skip-pr.js.map